import { ICustomerServive } from "../../../Frame/CustomerService/ICustomerService";
import { MeasureEdit } from "../../../Pages/Measure/MeasureEdit";

declare const fieldDoneDateId: number;

export class PagLaunchCockpitCustomerService implements ICustomerServive {

    onOpenMeasure = (measureId: string, templateInternalName: string, measureEdit: MeasureEdit, initMeasure: boolean): void => {
        measureEdit.onBeforeSave = () => {
            let input = document.getElementById(`dynField_${fieldDoneDateId}`) as HTMLInputElement;
            if (input) {
                input.disabled = false;
            }
        }
    }

}